'use strict';

var Events = {};
Events.EventsHandler = require('./EventsHandler');
Events.ListenerInfo = require('./ListenerInfo');
Events.Transitionable = require('./Transitionable');
Events.Util = require('./Util');

//----- 'static' functions ---
Events.register = function(listenerInfo) {
    jQuery(listenerInfo.element).on(listenerInfo.eventName, listenerInfo.observer);
};

Events.registerAll = function(listenerInfoArray) {
    for (var i = 0; i < listenerInfoArray.length; i++) {
        Events.register(listenerInfoArray[i]);
    }
};

Events.unregister = function(listenerInfo) {
    jQuery(listenerInfo.element).off( listenerInfo.eventName, listenerInfo.observer);
};

Events.unregisterAll = function(listenerInfoArray) {
    for (var i = 0; i < listenerInfoArray.length; i++) {
        Events.unregister(listenerInfoArray[i]);
    }
};

module.exports = Events;


//////////////////
// WEBPACK FOOTER
// ./mits/Events/index.js
// module id = 14
// module chunks = 0